import { render } from "./LinkSentPage.vue?vue&type=template&id=39f2e29e&ts=true"
import script from "./LinkSentPage.vue?vue&type=script&lang=ts"
export * from "./LinkSentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__